import { TokensUsageModes } from "@/api/models"
import { DEFAULT_USE_REASONING } from "@/utils/brand"

export enum QualityMode {
    Fast = "fast",
    Balanced = "balanced",
    Thorough = "thorough",
}

export function qualityModeToOverrides(mode: QualityMode): {
    tokens_usage_mode: TokensUsageModes
    reasoning_enabled: boolean
} {
    switch (mode) {
        case QualityMode.Fast:
            return { tokens_usage_mode: TokensUsageModes.Standard, reasoning_enabled: false }
        case QualityMode.Balanced:
            return {
                tokens_usage_mode: TokensUsageModes.Increased,
                reasoning_enabled: DEFAULT_USE_REASONING,
            }
        case QualityMode.Thorough:
            // Thorough sends Highest + reasoning_enabled. Backend preserves Highest only when
            // ALLOW_THOROUGH_HIGHEST=true and reasoning_enabled; otherwise Highest → Increased.
            return { tokens_usage_mode: TokensUsageModes.Highest, reasoning_enabled: true }
        default:
            return {
                tokens_usage_mode: TokensUsageModes.Increased,
                reasoning_enabled: DEFAULT_USE_REASONING,
            }
    }
}

export function overridesToQualityMode(tokensUsageMode: TokensUsageModes, reasoningEnabled: boolean): QualityMode {
    if (tokensUsageMode === TokensUsageModes.Standard && !reasoningEnabled) {
        return QualityMode.Fast
    }
    if (tokensUsageMode === TokensUsageModes.Highest && reasoningEnabled) {
        return QualityMode.Thorough
    }
    if (tokensUsageMode === TokensUsageModes.Increased) {
        return QualityMode.Balanced
    }
    return QualityMode.Balanced
}
